export default function PHP_fwrite() {
  return (
    <div>
      <h1>PHP_fwrite</h1>
    </div>
  );
}
